import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  DocumentCardChrome,
  DocumentTile,
  DocumentTileFooterBadge,
  getFileTypeBadge,
} from "@mytour/documents";
import type {CertificatRamonageDocument} from "@mytour/shared";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import {getEmailStatusBadgeState} from "@mytour/shared";
import {useState} from "react";
import {CertificatRamonageRecapModal} from "../../integrations/chimney-sweeping/CertificateComponents";
import "./AttestationCard.css";

dayjs.locale("fr");

type Props = {
  doc: CertificatRamonageDocument;
  customerId: string;
};

const PDF_BADGE = getFileTypeBadge("application/pdf");

export function AttestationCard({doc, customerId}: Props) {
  const [isRecapOpen, setIsRecapOpen] = useState(false);
  const badgeState = getEmailStatusBadgeState(doc.emailStatus);

  return (
    <DocumentCardChrome>
      <button
        type="button"
        className="attestation-card-open"
        aria-label={
          doc.hasFile
            ? `Consulter Ramonage n° ${doc.certificateNumber}`
            : `Reprendre le PDF du ramonage n° ${doc.certificateNumber}`
        }
        onClick={handleOpen}
      >
        <DocumentTile
          thumb={{kind: "badge", label: PDF_BADGE.label, color: PDF_BADGE.color}}
          title={`Ramonage n° ${doc.certificateNumber}`}
          subtitle={
            doc.hasFile
              ? `Rdv du ${dayjs(doc.eventDate).format("DD/MM")} · ${pluralizeAppareil(doc.appareilCount)}`
              : "Document enregistré, PDF à compléter · Reprendre le PDF"
          }
          footer={<DocumentTileFooterBadge label="Attestation" />}
          actions={
            badgeState && (
              <span
                aria-label={
                  badgeState === "uncertain"
                    ? "Envoi à vérifier"
                    : badgeState === "failed"
                      ? "Échec d'envoi"
                      : "Non envoyée"
                }
                className={`attestation-status-badge ${badgeState}`}
              >
                {badgeState === "failed" || badgeState === "uncertain" ? (
                  "!"
                ) : (
                  <FontAwesomeIcon icon="envelope" />
                )}
              </span>
            )
          }
        />
      </button>
      {isRecapOpen && (
        <CertificatRamonageRecapModal
          key={doc.eventId}
          eventId={doc.eventId}
          customerId={customerId}
          fileName={doc.fileName}
          onClose={handleClose}
        />
      )}
    </DocumentCardChrome>
  );

  function handleOpen() {
    setIsRecapOpen(true);
  }

  function handleClose() {
    setIsRecapOpen(false);
  }
}

function pluralizeAppareil(count: number): string {
  return `${count} appareil${count > 1 ? "s" : ""}`;
}
